// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip-content {\n  background: #001e38;\n  color: #fff;\n  padding: 5px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
